import { Dates } from '../../packages/dates';
import Metadata from '../../requests/apa/Metadata';
import Translator from '../../requests/apa/Translator';
import {
  getBookmark as apiGetBookmark,
  contentData as apiContentData,
  contentSerie as apiContentSerie,
  fetchFavoriteLoader
} from '../../requests/loader';
import RequestManager from '../../requests/RequestManager';
import favoriteDelTask from '../../requests/tasks/ficha/favoriteDelTask';
import favoriteTask from '../../requests/tasks/ficha/favoriteTask';
import Utils from '../../utils/Utils';
import CardHelper from '../Card/helpers';

export const getTalents = (roles = [], handleClick = () => {}) => {
  const talentArray = roles
    .map(role => {
      const { talent } = role && role.talents ? role.talents : { talent: [] };
      talent.forEach(t => {
        t.name = t.name ? t.name : '';
        t.fullname = t.fullname ? t.fullname : '';
        t.surname = t.surname ? t.surname : '';
        t.groupName = role.name;
      });
      return talent;
    })
    .reduce((curr, next) => {
      return curr.concat(next);
    }, []);

  return talentArray.map(talent => ({
    id: talent.id,
    group_id: talent.id,
    groupName: talent.groupName,
    title: `${talent.name} ${talent.surname}`,
    clickHandler: () => {
      handleClick(talent);
    }
  }));
};

export const getExternalTalents = (roles = [], handleClick = () => {}) => {
  const talentArray = roles
    .map(role => {
      const talent = role && role.talents ? role.talents : { talent: [] };
      if (talent.length > 0) {
        talent.forEach(t => {
          t.first_name = t.first_name ? t.first_name : '';
          t.last_name = t.last_name ? t.last_name : '';
          t.groupName = role.role_name;
          t.fullname = `${t.last_name}, ${t.first_name}`;
          t.name = t.first_name;
          t.surname = t.last_name;
        });
        return talent;
      } else {
        return [];
      }
    })
    .reduce((curr, next) => {
      return curr.concat(next);
    }, []);

  return talentArray.map(talent => ({
    id: talent.id,
    group_id: talent.id,
    groupName: talent.groupName,
    title: `${talent.first_name} ${talent.last_name}`,
    name: `${talent.first_name}`,
    surname: `${talent.last_name}`,
    fullname: `${talent.last_name} ${talent.first_name}`,
    cover: talent.image ? talent.image + '?impolicy=resize&vwidth=165' : null,
    clickHandler: () => {
      handleClick(talent);
    }
  }));
};

export const getSeasonId = contentData => {
  return (
    contentData &&
    contentData.group &&
    contentData.group.common &&
    contentData.group.common.extendedcommon &&
    contentData.group.common.extendedcommon.media &&
    contentData.group.common.extendedcommon.media.serieseason &&
    contentData.group.common.extendedcommon.media.serieseason.id
  );
};

export const getFormatTypes = contentData => {
  if (
    contentData &&
    contentData.group &&
    contentData.group.common &&
    contentData.group.common.extendedcommon &&
    contentData.group.common.extendedcommon.format &&
    contentData.group.common.extendedcommon.format.types
  ) {
    if (Array.isArray(contentData.group.common.extendedcommon.format.types)) {
      return contentData.group.common.extendedcommon.format.types;
    } else if (contentData.group.common.extendedcommon.format.types.indexOf(',') !== -1) {
      return contentData.group.common.extendedcommon.format.types.split(',');
    } else return [contentData.group.common.extendedcommon.format.types];
  }
  return [];
};

export const isValidGroupId = groupId => {
  const regex = new RegExp('^[0-9]+$');
  return regex.test(groupId);
};

export const getContentData = async groupId => {
  let contentData;
  try {
    contentData = await apiContentData(groupId);
  } catch (e) {
    contentData = null;
  }
  return new Promise(resolve => resolve(contentData));
};

export const getGroupIdToRedirect = seenLast =>
  seenLast && seenLast.episode && seenLast.episode.id ? seenLast.episode.id : null;

export const formatDuration = (duration='HH:mm:ss') =>{
  const durationDates = new Dates(`${new Dates().format('YYYY-MM-DD')} ${duration}`);
  return `${durationDates.hour()!==0? `${durationDates.hour()}h` : '' } ${durationDates.minute()}min`
}

export const getWatchWithBtnBGColor = (family) => {
  const genericBGColor =  Translator.get('generic_button_subscriptionDescription_background',  "#ECAF2A");
  if(family){
    const familyBGColor = Translator.get(`${family}_button_subscriptionDescription_background`,  '');
    if(familyBGColor){
      return familyBGColor;
    }
  }
  return genericBGColor;
}

export const parseRatingCode = ratingId => {
  if(!ratingId){
    return "";
  }
  const labelMetadata = Translator.get(`${ratingId}_rating_description_label`);
  return labelMetadata;
}

export const cutStringTitleVCard = originaltitle => {
  return Utils.cutPlayerString(originaltitle, 30);
}

export const parseContentData = (contentData) => {
  const {
    group: {
      common: {
        id: groupId,
        title = '',
        large_description = '',
        image_base_horizontal: imageClean = '',
        duration = '',
        extendedcommon = {}
      } = {}
    } = {}
  } = contentData;
  const image_clean_horizontal_shorted = `${imageClean}?impolicy=resize&vwidth=${Utils.isPlaystation4() ? '900' : '1200'}`;
  const {
    genres: { genre: genreArray = [] } = {},
    media = {},
    format: { types = '' } = {}
  } = extendedcommon;
  const {
    originaltitle ='',
    publishyear: year = '',
    rating: { code: ratingCode = '', id: ratingId = '' } = {},
    haspreview = 'false',
    language: { options: { option: languageArray } = {} } = {},
    proveedor: { nombre: providerName } = {},
    serie: { title: serieTitle = '' } = {},
    episode = null,
    serieseason: {
      id: seasonId = null
    } = {},
    islive
  } = media;
  const titleToDisplay = serieTitle || title;
  const isSerie = !!seasonId;
  if(isSerie){
    episode.name = title;
  }
  try{
    new Image().src =image_clean_horizontal_shorted;
  }
  catch(err){

  }
  return {
    types,
    groupId,
    title: titleToDisplay,
    episode,
    subtitle: cutStringTitleVCard(originaltitle),
    genders: genreArray.map(gender=>gender.desc),
    year,
    parentalRating: parseRatingCode(ratingId),
    synopsis: large_description,
    image: image_clean_horizontal_shorted,
    languages: languageArray,
    duration: formatDuration(duration),
    hasTrailer: haspreview ==='true',
    isSerie,
    isLive: islive === '1',
    seasonId,
    providerName: providerName.toLowerCase() ==='amco' ? 'Claro Video': providerName
  }
}

export const getSerieData = async contentData => {
  try {
    const {
      group: {
        common: {
          id: groupId,
          extendedcommon: {
            media: { episode: { season = '', number = '' } } = null
          } = {}
        } = {}
      } = {}
    } = contentData;
    const contentSerie = await apiContentSerie(groupId);
    const { seasons = [] } = contentSerie;
    const seasonsText =
      seasons.length > 0
        ? seasons.length === 1
        ? `1 ${Translator.get('season', 'Temporada')}`
        : `${seasons.length} ${Translator.get('season', 'Temporada')}s`
        : null;
    return new Promise(resolve =>
      resolve({
        seasonsText,
        serieData: {
          groupId,
          seasons,
          seasonNumber: season,
          episodeNumber: number
        }
      })
    );
  } catch (e) {
    return new Promise(resolve =>
      resolve({
        seasonsText: '',
        serieData: null
      })
    );
  }
};

export const resolveContentTalent = (universal_id, external, handleTalentClick = ()=>{} ) => {
  let resolveKey = JSON.stringify({
    default: {
      enabled: true,
      provider: 'gracenote'
    }
  });
  resolveKey = Utils.getApaMetadataKey('external_metadata', resolveKey);
  const providerTalent = resolveKey.enabled === true ? resolveKey.provider : null;
  let externalTalents = null;
  let provider_id = null;
  if (resolveKey) {
    if (
      providerTalent &&
      universal_id &&
      universal_id['metadata_providers'] &&
      universal_id['metadata_providers'][providerTalent]
    ) {
      // Verificar si viene el array de talentos
      provider_id =
        universal_id['metadata_providers'][providerTalent]['provider_id'];
      const arrTalent = external[providerTalent] && external[providerTalent]['cast'];
      if (arrTalent) {
        externalTalents = getExternalTalents(
          external[providerTalent]['cast'],
          handleTalentClick
        );
      }
    }
  }

  return { externalrole: externalTalents, provider_id };
};

export const checkFavoritedContent = async (groupId, user) => {
  let favoritedContent;
  const filterList = Utils.getAPAFilterList();
  const favs = await fetchFavoriteLoader(user, filterList);
  if (
      favs &&
      favs.response &&
      favs.response &&
      favs.response.groups &&
      Array.isArray(favs.response.groups)
  ) {
      favoritedContent = favs.response.groups.find(el => el.id === groupId);
  }
  return new Promise(resolve => resolve(favoritedContent && typeof favoritedContent === 'object'));
}

export const getBookmark = async (groupId, isAnonymous, lastTouchSeen) => {
  if (isAnonymous){
      return new Promise(resolve =>
          resolve({ time: '00:00:00', progress: 0, image_still: '', image_frames: '' })
      );
  }
  try {
      const bookmark = await apiGetBookmark(groupId, lastTouchSeen);
      const { response: { groups = [] } = {} } = bookmark;
      const [firstBookmark = {}] = groups;
      const {
          image_still = '',
          image_frames = '',
          vistime: { last: { time = '00:00:00', progress = 0 } = {} } = {}
      } = firstBookmark;
      Utils.isModalHide() && Utils.setInitialFocusChangeTime(".elementopredeterminado", 0);
      return new Promise(resolve => resolve({ time, progress, image_still, image_frames }));
  } catch (e) {
      Utils.isModalHide() && Utils.setInitialFocusChangeTime(".elementopredeterminado", 0);
      return new Promise(resolve =>
          resolve({ time: '00:00:00', progress: 0, image_still: '', image_frames: '' })
      );
  }
}


export const favoriteToggleRequest = (requestParams, isFavorite, successCallBack = ()=>{}, failedCallBack = ()=>{}) => {
  const request = isFavorite ? new favoriteDelTask(requestParams) : new favoriteTask(requestParams);
        RequestManager.addRequest(request)
        .then( data => {
          successCallBack(data);
        })
        .catch(e => {
          failedCallBack(e);
        });
}

export const isAnonymousFromProps = (props = {}) => {
  const {
      user : {
          isAnonymous = true
      } = {}
  } = props;
  return isAnonymous;
}

export const getIgnoreSeenLastFromMatchParams = (props = {}) => {
  const {
      match: {
          params: {
              ignoreSeenLast = false
          } = {}
      } = {}
  } = props;
  return ignoreSeenLast;
}

export const getGroupIdFromMatchParams = (props ={}) => {
  const {
      match: {
          params: {
              groupId = null
          } = {}
      } = {}
  } = props;
  return groupId;
}

const thereIsSeason = () => {
  return document.querySelector(`#episodesvcard_classic_link_1`);
}

const thereIsTalents = () => {
  return document.querySelector(`#vcardtalentsribbon_tooncharacter_link_1`);
}

const thereIsRecommendations = () => {
  return document.querySelector(`#vcardrecomendationribbon_classic_link_1`);
}

export const mapRecommendationToSpecialRibbonProps = (recommendations, onRecommendationClick) => {
  const id = 'vcard-recomendation-ribbon'
  const title = Translator.get('vcard_ribbon_recommendations_label','Otras personas que vieron este contenido, también vieron:');
  const items = recommendations.map(r => {
      return {
          id: r.id,
          title: r.title,
          group_id: r.id,
          cover: r.image_small,
          proveedor_code: r.proveedor_code,
          provider:
              r.proveedor_code === 'amco' ? 'default' : r.proveedor_code,
          format_types: r.format_types.split(','),
          live_enabled: r.live_enabled,
          type: r.live_enabled === '1' ? 'live' : 'vod',
          is_series: r.is_series,
          clickHandler: () => {
              onRecommendationClick(r.id);
          }
      };
  });
  return {
      id,
      type: "landscape",
      title,
      byUser:false,
      offset: null,
      showFooter: false,
      isCarrouselTV: false,
      url: "",
      items,
      index: 0,
      bottomRibbon: false,
      key: id,
      focusHandler:()=>{},
      forceUpdateGrid:()=>{},
      hasRecordings: false,
      api:"",
      handleDeleteFromRibbonRecordings:()=>{},
      idsRibbonsUpAndDown: {
        0: {
          focusUp: thereIsSeason() ? "#episodesvcard_classic_link_1" : ".elementopredeterminado",
          focusDown: thereIsTalents() ? "#vcardtalentsribbon_tooncharacter_link_1" : null
        }
      }
  }
}

export const mapTalentToSpecialRibbonProps = (talents = [], content_name) => {
  const id = 'vcard-talents-ribbon'
  const title = Translator.get('vcard_ribbon_talents_label', 'Talentos');
  const items = talents.map(t=>{
    t.typeRender ="a";
    t.text_highlight = t.title;
    // se quita rol hasta que haya definicion del lenguaje por el STV-14440
    //t.text_subtitle = t.groupName;
    t.content_name = content_name
    if(!t.cover){
      t.cover = CardHelper.getPlaceholder(t.groupName && t.groupName.toLowerCase());
    }
    return t;
  });
  return {
      id,
      type: "tooncharacter",
      title,
      byUser:false,
      offset: null,
      showFooter: false,
      isCarrouselTV: false,
      url: "",
      items,
      index: 0,
      bottomRibbon: false,
      key: id,
      focusHandler:()=>{},
      forceUpdateGrid:()=>{},
      hasRecordings: false,
      api:"",
      handleDeleteFromRibbonRecordings:()=>{},
      idsRibbonsUpAndDown: {
        0: {
          focusUp: thereIsRecommendations() ? "#vcardrecomendationribbon_classic_link_1" : null,
          focusDown: null
        }
      }
  }
}

export const mapEpisodeExtraInfo = ({item = null}) => {
  if(!item){
    return null;
  }
  const {
    data : {
      title_episode = '',
      episode_number = '',
      description = '',
    } = {}
  } = item;
  if(!title_episode || !episode_number || !description){
    return null;
  }
  return {
    title_episode,
    episode_number,
    description
  };
}



// WEBPACK FOOTER //
// ./src/components/Ficha/fichaHelper.js